import { useState, useEffect } from 'react';

import { PageHeader, Skeleton } from 'antd';
import { useHistory } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { getUserPrivateStation } from '../../hooks/users';
import StationConfigForm from '../organisms/StationForm/StationConfigForm';

const StationCreatePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  .ant-page-header {
    padding: 24px 0;
  }

  .ant-page-header-heading-left {
    margin: 0;
  }
`;

const StationCreatePage = () => {
  const [usersPrivateStation, setUsersPrivateStation] = useState([]);
  const [stationType, setStationType] = useState('');
  const history = useHistory();
  const initialValues = {
    active: true,
    chargeBoxId: '',
    endpointAddress: '',
    address: {
      street: '',
      houseNumber: '',
      zipCode: '',
      city: '',
      state: '',
      country: 'BR',
    },
    description: '',
    locationLatitude: '',
    locationLongitude: '',
    showLocation: false,
    typeOf: 'PUBLIC',
    isOpen_24Hours: true,
    openTime: null,
    closeTime: null,
    moneyPerKilowattCost: '0.0',
    moneyPerDurationCost: '0.0',
    moneyPerTransactionCost: '0.0',
    moneyPerKilowattIncome: '0.0',
    moneyPerDurationIncome: '0.0',
    moneyPerTransactionIncome: '0.0',
    hasSocPercentage: false,
    isHubjectCompatible: false,
    chargeBoxGroupPk: null,
    chargeBoxGroupName: T('Unspecified'),
    externalId: null,
    paymentChargeTypeCost: 'KWH',
    paymentChargeTypeIncome: 'KWH',
    paymentChargeByIncome: 'CHARGE_BOX',
    taxIncome: '0',
    reservation: false,
    customizePerDay: false,
    autoStopOnClose: false,
    schedules: [],
    photos: [],
    isTenantDeviceReader: false,
    deviceReaderMac: null,
    isOcpiCompatible: false,
    idleExemptAlwaysCharge: true,
    idleExemptCustomizePerDay: false,
    idleExemptSchedules: [],
  };

  const loadUserPrivateStations = async () => {
    try {
      const { userPrivateStationList } = await getUserPrivateStation('');

      console.log(userPrivateStationList);
      setUsersPrivateStation(userPrivateStationList);
    } catch {
      //
    }
  };

  useEffect(() => {
    if (stationType === 'PRIVATE') {
      loadUserPrivateStations();
    }
  }, [stationType]);

  return (
    <StationCreatePageWrapper>
      <PageHeader
        onBack={() => history.goBack()}
        title={T('Creating Chargebox')}
      />

      <StationConfigForm
        initialValues={initialValues}
        type='create'
        setStationType={setStationType}
        usersPrivateStation={usersPrivateStation}
      />
    </StationCreatePageWrapper>
  );
};

export default StationCreatePage;
